// extracted by mini-css-extract-plugin
export default {"SearchPanel":"py_a bic_ea bic_ke bic_ju bic_a bic_j bic_so bic_sp","SearchPanel__icon":"py_b bic_vo bic_hi bic_su bic_va","SearchPanel__input":"py_c bic_jb bic_eg bic_z"};